/* eslint-disable react/jsx-props-no-spreading */
import { FC, useState } from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import { useSelector } from 'react-redux';

import { NativeSortSelectProps } from 'components/Sections/PsychicsSetMediumSizeImagesClone/declarations';
import { mapBlocksParagraphWithModifiableText } from 'lib/richTextMappers';
import type { RichTextParsersConfig } from 'types/objectTypes';
import { CommonRichText } from 'components/Shared/SharedComponents';
import { CustomerType } from 'constants/enums';
import type { Store } from 'app-redux/types/storeTypes';

import styles from '../PsychicFilter.module.scss';
import mobileStyles from '../PsychicFilterMobile.module.scss';

const getParsersConfig = (): RichTextParsersConfig => ({
  [BLOCKS.PARAGRAPH]: {
    classNames: styles.placeholder,
    mapper: mapBlocksParagraphWithModifiableText((text: string) => text.split(' ')?.[0]),
  },
});

const SORT_SELECT_ID = 'psychic-sort-select';

const NativeSortSelect: FC<NativeSortSelectProps> = ({
  options,
  initialValue = '',
  onChange,
  sortTitle,
}) => {
  const isAuthenticated = useSelector((store: Store) => store.server.auth.isAuthenticated);
  const [dataAttributes, setDataAttributes] = useState<Record<string, string | number>>({});

  return (
    <div className={mobileStyles.sortSelect}>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor={SORT_SELECT_ID} className={mobileStyles.label}>
        <CommonRichText
          content={sortTitle}
          parsersConfig={getParsersConfig()}
        />
      </label>
      <select
        id={SORT_SELECT_ID}
        {...dataAttributes}
        className={mobileStyles.nativeSortSelect}
        value={initialValue}
        onChange={(e) => {
          onChange?.(e.target.value);
          setDataAttributes({
            'data-action': e.target.selectedOptions[0].innerText,
            'data-category': 'Sort',
            'data-label': isAuthenticated ? CustomerType.EC.toUpperCase() : CustomerType.NC.toUpperCase(),
          });
        }}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default NativeSortSelect;
